import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { RootState } from 'store/store';
import PreApprovedHeader from './header/PreApprovedHeader';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { Grid } from '@mui/material';
import { CommonButton } from 'sharedComponents/index';

const Step11: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  // Hooks
  const { t } = useTranslation();

  const { control } = useFormContext();

  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const hasCalledNextStep = React.useRef(false);

  // React Hook Form Trigger
  const nextStep = () => {
    // if (hasCalledNextStep.current) return;
    // hasCalledNextStep.current = true;
    // onNext?.();
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <>
      <PreApprovedHeader currentStep={2} />

      <div className='dr-widget-steps pre-approved-steps'>
        <div className='dr-widget-steps__content'>
          <h2 className='dr-widget-steps__title mb-3'>{t('Applicant Summary')}</h2>
          <Grid container spacing={2} marginBottom={3}>
            <Grid item md={6} sm={12} xs={12}>
              <div className='pre-approved-summary-box'>
                <div className='pre-approved-summary-box__header'>
                  <h4 className='pre-approved-summary-box__title'>Personal Information</h4>
                  <button type='button' className='edit-btn' onClick={() => onBack?.(8)}>
                    <EditIcon />
                  </button>
                </div>
                <div className='pre-approved-summary-box__body'>
                  <ul className='value-with-lbl-list list-unstyled mb-0'>
                    <li>
                      <div className='value-with-lbl-list__lbl'>First Name</div>
                      <div className='value-with-lbl-list__value'>John</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Middle Name</div>
                      <div className='value-with-lbl-list__value'>Jsmith</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Last Name</div>
                      <div className='value-with-lbl-list__value'>Doe</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Date of Birth</div>
                      <div className='value-with-lbl-list__value'>11/12/1989</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Phone Number</div>
                      <div className='value-with-lbl-list__value'>7343959589</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Email Address</div>
                      <div className='value-with-lbl-list__value'>johnd@gmail.com</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Address</div>
                      <div className='value-with-lbl-list__value'>Suit 130, 4275 King</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>City</div>
                      <div className='value-with-lbl-list__value'>Canada</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Province</div>
                      <div className='value-with-lbl-list__value'>Ontario</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Postal code</div>
                      <div className='value-with-lbl-list__value'>1A1 A11</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Years at Address</div>
                      <div className='value-with-lbl-list__value'>5 years</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Residential Status</div>
                      <div className='value-with-lbl-list__value'>Rent</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Monthly Residential Payment</div>
                      <div className='value-with-lbl-list__value'>$829</div>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className='pre-approved-summary-box'>
                <div className='pre-approved-summary-box__header'>
                  <h4 className='pre-approved-summary-box__title'>Employment Information</h4>
                  <button type='button' className='edit-btn' onClick={() => onBack?.(9)}>
                    <EditIcon />
                  </button>
                </div>
                <div className='pre-approved-summary-box__body'>
                  <ul className='value-with-lbl-list list-unstyled mb-0'>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Employment Status</div>
                      <div className='value-with-lbl-list__value'>Dabadu.ai</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Employer Name</div>
                      <div className='value-with-lbl-list__value'>Full Time</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Occupation</div>
                      <div className='value-with-lbl-list__value'>Front end developer</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Address</div>
                      <div className='value-with-lbl-list__value'>Suit 130, 4275 King St E, Kitchener</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>City</div>
                      <div className='value-with-lbl-list__value'>Canada</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Province</div>
                      <div className='value-with-lbl-list__value'>Ontario</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Postal Code</div>
                      <div className='value-with-lbl-list__value'>1A1 A11</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Total Years of Employment</div>
                      <div className='value-with-lbl-list__value'>4 years</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Total Month of Employment</div>
                      <div className='value-with-lbl-list__value'>3 month</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Gross Employment Income</div>
                      <div className='value-with-lbl-list__value'>$1080.00</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Income Frequency</div>
                      <div className='value-with-lbl-list__value'>Monthly</div>
                    </li>
                    <li>
                      <div className='value-with-lbl-list__lbl'>Other Income Type</div>
                      <div className='value-with-lbl-list__value'>None</div>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

const StepperForm11 = React.forwardRef(Step11);

export default StepperForm11;
